"use client";

import React from "react";
import { Clock, Shield, Zap } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  title: "Maryland Weather Experts",
  description: "We understand the unique challenges of Maryland's climate, from heavy humidity to intense seasonal storms that can compromise your roof's integrity.",
  icon: Zap
}, {
  title: "Rapid Storm Response",
  description: "When severe weather strikes, our local team is ready to respond quickly. We prioritize emergency repairs to prevent further damage to your home.",
  icon: Clock
}, {
  title: "Local Homeowner Focus",
  description: "As a community-based business, we are committed to providing neighbors with honest assessments and durable solutions for long-term protection.",
  icon: Shield
}];
export default function ServiceAreaIntroduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224816" id="service-area-introduction" className="bg-background text-foreground py-20 px-4 md:px-8 lg:px-16 overflow-hidden">
      <div ref={ref} className={`max-w-screen-xl mx-auto transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-primary mb-4">
            Your Local Roofing Specialists
          </h2>
          <p className="text-muted-foreground font-default max-w-2xl mx-auto text-lg">
            Eagle Exteriors brings regional expertise and fast response times to every Maryland home we serve.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <Card key={i} data-index={i} className="group border border-primary/10 bg-card transition-all duration-300 hover:-translate-y-1 hover:border-secondary hover:shadow-lg hover:shadow-primary/5 rounded-md">
                <CardHeader className="pb-4">
                  <div className="w-14 h-14 rounded-md bg-secondary/10 flex items-center justify-center mb-4 group-hover:bg-secondary/20 transition-colors">
                    <Icon className="w-8 h-8 text-secondary" />
                  </div>
                  <CardTitle className="font-default text-xl text-primary group-hover:text-secondary transition-colors">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="font-default text-muted-foreground leading-relaxed">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}